import { Table } from "antd";
import { useSearchParams } from "react-router-dom";

import { PAGE_LENGTH } from "../../config";
import Loader from "../loader";
import CustomPagination from "../../common/CustomPagination";

const LeadTableView = ({
  loading,
  rowSelection,
  columns,
  executiveEmployeeList,
  paginationValue,
  companyFilterList,
  onPageChange,
}) => {
  const [searchParams] = useSearchParams();

  return (
    <div id="content-wrapper" className="tw-flex tw-flex-col">
      <div id="content">
        <div className="tw-pl-0 tw-pr-0">
          {!loading ? (
            <div className="tw-custom-table-container tw-h-[calc(100vh-215px)] tw-flex tw-flex-col">
              <Table
                rowSelection={{
                  type: "checkbox",
                  ...rowSelection,
                }}
                columns={columns?.map((col) => ({
                  ...col,
                  onCell: (record, rowIndex) => ({
                    className: "word-break-keep-all",
                  }),
                }))}
                dataSource={executiveEmployeeList}
                className="tw-custom-table tw-custom-cell-space"
                pagination={false}
                tableLayout="fixed"
                scroll={false}
              />
              <CustomPagination
                total={companyFilterList?.totalExecutiveCount}
                current={searchParams.get("page") || paginationValue?.start + 1}
                pageSize={
                  parseInt(PAGE_LENGTH) >
                  parseInt(companyFilterList?.totalExecutiveCount)
                    ? companyFilterList?.totalExecutiveCount
                    : parseInt(searchParams.get("size"))
                      ? parseInt(searchParams.get("size"))
                      : PAGE_LENGTH
                }
                onChange={onPageChange}
                noBorder={true}
              />
            </div>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadTableView;
